import React from "react";

import { NextImageLP } from "@/components/displays";

import ImgBanner from "$/images/campaign/freeDeliveryfee/campaign_freedeliveryfee.png";

export interface FreeShippingBannerProps {
  width?: number;
}

export function FreeShippingBanner({ width = 750 }: FreeShippingBannerProps): React.ReactNode {
  return <NextImageLP src={ImgBanner} width={width} alt="送料無料キャンペーン" />;
}
